import { render, staticRenderFns } from "./PartidasView.vue?vue&type=template&id=879c5172&"
import script from "./PartidasView.vue?vue&type=script&lang=js&"
export * from "./PartidasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports